<div style="flex: 6 1 0">
    @if (showLabel) {
        <label class="mb-1 inline-block">
            {{ label | translate }}
            @if (isRequired()) {
                <span class="text-red-500">*</span>
            }
        </label>
    }
    @if (!formControl) {
        <ng-select
            [items]="departments"
            bindLabel="name"
            [multiple]="multiple"
            [compareWith]="compareWith"
            [groupBy]="'parentDepartment.name'"
            [(ngModel)]="value"
            [placeholder]="placeholder | translate"
            (ngModelChange)="onSelectionChange($event)"
        >
            <ng-template ng-option-tmp let-item="item">
                <div class="flex flex-col">
                    <span class="font-medium">{{ item.name }}</span>
                    @if (
                        item.parentDepartment?.name ||
                        item.secondParentDepartment?.name ||
                        item.thirdParentDepartment?.name
                    ) {
                        <div class="text-sm text-gray-500">
                            @if (item.parentDepartment?.name) {
                                <div class="block font-semibold">
                                    {{ item.parentDepartment.name }}
                                </div>
                            }
                            @if (item.secondParentDepartment?.name) {
                                <div class="block">
                                    {{ item.secondParentDepartment.name }}
                                </div>
                            }
                            @if (item.thirdParentDepartment?.name) {
                                <div class="block">
                                    {{ item.thirdParentDepartment.name }}
                                </div>
                            }
                        </div>
                    }
                </div>
            </ng-template>
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
                <span class="ng-value-icon left" (click)="clear(item)">×</span>
                <span class="ng-value-label font-medium">{{ item.name }}</span>
            </ng-template>
            <ng-template ng-optgroup-tmp let-item="item">
                <span class="font-bold text-gray-700">{{ item }}</span>
            </ng-template>
        </ng-select>
    }
    @if (formControl) {
        <ng-select
            [items]="departments"
            bindLabel="name"
            [multiple]="multiple"
            [compareWith]="compareWith"
            [groupBy]="'parentDepartment.name'"
            [formControl]="formControl"
            [placeholder]="placeholder | translate"
        >
            <ng-template ng-option-tmp let-item="item">
                <div class="flex flex-col">
                    <span class="font-medium">{{ item.name }}</span>
                    @if (
                        item.parentDepartment?.name ||
                        item.secondParentDepartment?.name ||
                        item.thirdParentDepartment?.name
                    ) {
                        <div class="text-sm text-gray-500">
                            @if (item.parentDepartment?.name) {
                                <div class="block font-semibold">
                                    {{ item.parentDepartment.name }}
                                </div>
                            }
                            @if (item.secondParentDepartment?.name) {
                                <div class="block">
                                    {{ item.secondParentDepartment.name }}
                                </div>
                            }
                            @if (item.thirdParentDepartment?.name) {
                                <div class="block">
                                    {{ item.thirdParentDepartment.name }}
                                </div>
                            }
                        </div>
                    }
                </div>
            </ng-template>
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
                <span class="ng-value-icon left" (click)="clear(item)">×</span>
                <span class="ng-value-label font-medium">{{ item.name }}</span>
            </ng-template>
            <ng-template ng-optgroup-tmp let-item="item">
                <span class="font-bold text-gray-700">{{ item }}</span>
            </ng-template>
        </ng-select>
    }

    <!-- Validation Error Message -->
    @if (shouldShowValidationError()) {
        <div class="mt-1 text-xs text-red-500">
            {{ 'translate_this_field_is_mandatory' | translate }}
        </div>
    }
</div>
